import React, { useState, useEffect } from 'react';
import'./scrollTop.css';
import { useLocation } from 'react-router-dom';

function ScrollTop() {

    const {pathname} = useLocation();

    useEffect(() => {
        window.scrollTo(0,0);
    },[pathname]);

    

  const [isVisible, setIsVisible] = useState(false);

  // إظهار/إخفاء الزر عند الانتقال بين الصفحات وعند الوصول لمستوى معين من التمرير
  useEffect(() => {
    window.addEventListener("scroll", toggleVisibility);
    return () => {
      window.removeEventListener("scroll", toggleVisibility);
    };
  }, []);

  // تبديل إظهار/إخفاء الزر بناءً على موضع التمرير
  const toggleVisibility = () => {
    if (window.pageYOffset > 300) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  // الانتقال إلى الجزء العلوي من الصفحة
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  };

  return (
    <div className="scroll-to-top">
      {isVisible && (
        <button className='top-btn' onClick={scrollToTop}>
          <i className='bi bi-arrow-up-circle'></i>
        </button>
      )}
    </div>
  );
}

export default ScrollTop;
